module.exports = __webpack_public_path__ + "img/custom-reminder.0f32d9fb.svg";